import React from 'react';
import './StaticPage.css';

export default function Impressum() {
  return (
    <div className="static-page">
      <nav className="static-nav">
        <a href="/" className="logo-text">
          <span style={{color:'#0D9488'}}>ICH</span>TYP<span className="logo-de">.DE</span>
        </a>
      </nav>

      <main className="static-main privacy-main">
        <div className="privacy-card">
          <h1 className="privacy-title">Impressum</h1>
          <p className="privacy-date">Angaben gemäß § 5 TMG</p>

          <section className="privacy-section">
            <h2>Betreiber</h2>
            <div className="privacy-box">
              <strong>ICHTYP.DE</strong><br/>
              Musterstraße 1<br/>
              10115 Berlin<br/>
              Deutschland
            </div>
          </section>

          <section className="privacy-section">
            <h2>Kontakt</h2>
            <div className="privacy-box">
              E-Mail: <a href="mailto:kontakt@ichtyp.de" style={{color:'var(--teal)'}}>kontakt@ichtyp.de</a><br/>
              Website: <a href="https://ichtyp.de" style={{color:'var(--teal)'}}>https://ichtyp.de</a>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Verantwortlich für den Inhalt</h2>
            <div className="privacy-box">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br/><br/>
              ICHTYP.DE<br/>
              Musterstraße 1<br/>
              10115 Berlin<br/>
              Deutschland
            </div>
          </section>

          <section className="privacy-section">
            <h2>Haftungsausschluss</h2>

            <h3>Haftung für Inhalte</h3>
            <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>

            <h3>Haftung für Links</h3>
            <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>

            <h3>Urheberrecht</h3>
            <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
          </section>

          <section className="privacy-section">
            <h2>Streitschlichtung</h2>
            <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer" style={{color:'var(--teal)'}}>https://ec.europa.eu/consumers/odr/</a></p>
            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
          </section>

        </div>
      </main>

      <footer className="static-footer">
        <p>© 2025 ICHTYP.DE · <a href="/datenschutz">Datenschutz</a> · <a href="/abbestellen">Abmelden</a></p>
      </footer>
    </div>
  );
}
